<form [formGroup]="form" (submit)="onSubmit()">
  <mat-form-field appearance="fill">
    <mat-label>Color</mat-label>
    <input matInput formControlName="color" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Intensity</mat-label>
    <input type="number" matInput formControlName="intensity" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Angle</mat-label>
    <input type="number" matInput formControlName="angle" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Decay</mat-label>
    <input type="number" matInput formControlName="decay" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Distance</mat-label>
    <input type="number" matInput formControlName="distance" (blur)="onSubmit()" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Penumbra</mat-label>
    <input type="number" matInput formControlName="penumbra" (blur)="onSubmit()" />
  </mat-form-field>
  <br />
  <mat-checkbox formControlName="castShadow" (change)="onSubmit()">Cast shadow</mat-checkbox>
  <button style="display: none" type="submit"></button>
</form>
